export default function SetupGate() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-milk-50 px-4">
      <div className="card p-8 max-w-xl text-sm leading-6 text-slate-700">
        <h1 className="text-xl font-extrabold text-milk-800 mb-2">⚙️ 초기 설정이 필요합니다</h1>
        <p className="mb-3">
          Firebase 프로젝트와 V-World API 키를 연결해야 합니다. 프로젝트 루트의 <code className="bg-slate-100 px-1 rounded">.env.example</code> 파일을 참고해 <code className="bg-slate-100 px-1 rounded">.env</code> 를 만들고 아래 값을 채워주세요.
        </p>
        <ol className="list-decimal pl-5 space-y-1">
          <li><a className="text-milk-600 underline" href="https://console.firebase.google.com" target="_blank" rel="noreferrer">Firebase Console</a>에서 프로젝트 생성 → 웹앱 등록 → 설정 복사</li>
          <li><a className="text-milk-600 underline" href="https://www.vworld.kr" target="_blank" rel="noreferrer">브이월드</a> 가입 후 Geocoder API 2.0 키 발급 (도메인 허용 목록에 배포 주소 추가)</li>
          <li><a className="text-milk-600 underline" href="https://openapi.sk.com" target="_blank" rel="noreferrer">TMap API 포털</a>에서 앱 등록 후 AppKey 발급</li>
          <li><code>npm install</code> → <code>npm run dev</code></li>
        </ol>
      </div>
    </div>
  );
}
